import { ApiResponse, DataObject, DataPaginate } from "@/types";
import { SectorFormPayload } from "./validation";
import { fetcher, sendData } from "@/services/api/fetcher";
import { useFormMutation } from "@/hooks/useFormMutation";
import { useQuery } from "@tanstack/react-query";

// get
const getSector = async (
  query?: string
): Promise<ApiResponse<DataPaginate<SectorResponse>>> => {
  return await fetcher(query ? `master/bidang?${query}` : `master/bidang`);
};

export const useGetSector = (query?: string) => {
  return useQuery<ApiResponse<DataPaginate<SectorResponse>>, Error>(
    ["useGetSector", query],
    () => getSector(query),
    {
      keepPreviousData: true,
      refetchIntervalInBackground: true,
    }
  );
};

// get by id
export const getSectorId = async (
  id: number
): Promise<ApiResponse<DataObject<SectorResponse>>> => {
  return await fetcher(`master/bidang/${id}`);
};

export const useGetSectorId = (id: number) => {
  return useQuery<ApiResponse<DataObject<SectorResponse>>, Error>(
    ["useGetSectorId", id],
    () => getSectorId(id)
  );
};

// post
export const useSector = (method: "POST" | "PUT" = "POST", id?: number) => {
  return useFormMutation<
    ApiResponse<DataObject<SectorFormPayload>>,
    Error,
    SectorFormPayload
  >({
    mutationFn: async (
      data
    ): Promise<ApiResponse<DataObject<SectorFormPayload>>> => {
      const endpoint = id ? `master/bidang/${id}` : "master/bidang";
      const delay = new Promise((resolve) => setTimeout(resolve, 2000));
      const response: ApiResponse<DataObject<SectorFormPayload>> =
        await sendData(endpoint, data, method);
      await delay;
      return response;
    },
    loadingMessage:
      method === "POST" ? "Menyimpan data..." : "Memperbarui data...",
    successMessage:
      method === "POST"
        ? "Data berhasil ditambahkan"
        : "Data berhasil diperbarui",
  });
};
